<template>
    <div class="modal-card" style="width: 65vw; height:70vh">
        <header class="modal-card-head">
            <p class="modal-card-title">{{ __('strings.discount.add_new_discount') }}</p>
            <button
                type="button"
                class="delete"
                @click="$emit('close')"/>
        </header>
        <section class="modal-card-body">
            <b-field horizontal :label="__('strings.discount.name')">
                <b-input v-model="input.name" type="text"></b-input>
            </b-field>
            <b-field horizontal :label="__('strings.discount.range_date')">
                <div class="columns is-align-items-center">
                    <div class="column is-5">
                        <b-datetimepicker
                            rounded
                            v-model="date.startDate"
                            :date-parser="(d) => {moment(d, dateFormat).ISO}"
                            placeholder="Click to select..."
                            icon="calendar-today"
                            :locale="locale"
                            horizontal-time-picker :min-datetime="now">
                        </b-datetimepicker>
                    </div>
                    <div class="column is-5">
                        <b-datetimepicker
                            rounded
                            v-model="date.endDate"
                            :date-parser="(d) => {moment(d, dateFormat)}"
                            placeholder="Click to select..."
                            icon="calendar-today"
                            :locale="locale"
                            horizontal-time-picker :min-datetime="tomorrow">
                        </b-datetimepicker>
                    </div>
                    <div class="column is-1">
                        {{ `${deltaDays} GIORNI` }}
                    </div>
                </div>

            </b-field>
            <b-field class="file is-primary is-expanded"  :class="{'has-name': !!input.file}">
                <b-upload v-model="input.file" class="file-label" rounded>
                    <span class="file-cta">
                        <b-icon class="file-icon" icon="upload"></b-icon>
                        <span class="file-label">Choose file</span>
                    </span>
                    <span class="file-name" v-if="input.file">
                        {{ input.file.name }}
                    </span>
                </b-upload>
            </b-field>

            <b-notification
                v-if="Object.keys(this.errors).length"
                type="is-danger"
                has-icon>
                <ul v-for="(error, key) in errors" :key="'error-'+key">
                    <li v-for="(message, index) in error" :key="'error-message-'+index" v-text="message"></li>
                </ul>
            </b-notification>
        </section>
        <footer class="modal-card-foot is-justify-content-flex-end">
            <div class="buttons">
                <b-button type="is-primary"
                          @click="upload"
                          :disabled="(date.cm_start_date >= date.cm_end_date) || !input.name "
                >Upload</b-button>
                <b-button @click="$emit('close')">
                    {{ __('strings.close') }}
                </b-button>
            </div>
        </footer>
    </div>
</template>

<script>
import moment from "moment";

export default {
    props: {
        retailers: {
            required: true,
            type: Array
        },
    },
    data() {
        return {
            dateFormat: "YYYY-MM-DD HH:mm:ss",
            locale: moment.locale(),
            errors: {},
            loading: false,
            input: {
                retailer_id: 1,
                name: undefined,
                file: null,
                start_date: undefined,
                end_date: undefined,
            },
            date: {
                startDate: new Date(),
                endDate: new Date(),
                cmStartDate: moment().valueOf(),
                cmEndDate: moment().valueOf(),
            }
        }
    },
    mounted() {
        this.input.start_date = moment.utc().format(this.dateFormat);
        this.input.end_date = moment.utc().format(this.dateFormat);

        this.date.startDate = this.now;
        this.date.endDate = this.tomorrow;
    },
    methods: {
        upload() {
            this.loading = true;
            let formData = new FormData;
            for (let [key, value] of Object.entries(this.input)) {
                formData.append(key, value);
            }

            axios.post('/discount/plan/upload', formData)
                .then(response => this.$emit('uploaded', response.data))
                .catch(error => this.errors = error.response.data.errors)
                .finally(() => this.loading = false)
        }
    },
    computed: {
        deltaDays() {
            if (this.date.cmStartDate < this.date.cmEndDate) {
                return moment(this.date.endDate).diff(moment(this.date.startDate), 'days');
            }

            return 0;
        },
        now() {
            return new Date();
        },
        tomorrow() {
            let date = new Date();
            date.setDate(date.getDate() + 1);
            return date;
        }
    },
    watch: {
        "date.startDate"(value) {
            this.input.start_date = moment.utc(value).format(this.dateFormat);
            this.date.cmStartDate = moment(value).valueOf();
        },
        "date.endDate"(value) {
            this.input.end_date = moment.utc(value).format(this.dateFormat);
            this.date.cmEndDate = moment(value).valueOf();
        }
    }
}
</script>
